import DashboardPage from './components/DashboardPage';
import Empty from '../../components/base/Empty';

const routes = [
  {
    path: '/',
    name: 'menu.dashboard',
    icon: 'dashboard',
    customIcon: true,
    loginRequired: true,
    component: DashboardPage,
    weight: 1,
    permission: ['frontend_menu_dashboard'],
    children: [],
  },
  {
    path: '/',
    to: 'parking-meters',
    name: 'menu.dashboard',
    icon: 'dashboard',
    customIcon: true,
    loginRequired: true,
    component: Empty,
    weight: 1,
    permission: [],
    children: [],
    forMobile: true,
    redirect: true,
  },
];

export default routes;
